import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AuthService } from '../authentication/authentication.service';
import { PrivateService } from './private.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class SharedService {

  constructor(
    private privateService: PrivateService,
    private router: Router
  ) { }

  private openModalSource = new Subject<void>();
  openModal$ = this.openModalSource.asObservable();

  triggerOpenModal() {
    this.openModalSource.next();
  }

  // async initializeApp(): Promise<void> {
  //   try {
  //     this.privateService.getApiTime().subscribe(
  //       (response) => {
  //       },
  //       async (error) => {
  //         localStorage.clear();
  //         this.router.navigate(['login']);
  //       }
  //     );
  //   } catch (error) {
  //   }
  // }
}